import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

import { getCicAlertCounts } from './getCicAlertCounts';

export const GET_CIC_ALERT_REQUEST = 'GET_CIC_ALERT_REQUEST';
export const GET_CIC_ALERT_SUCCESS = 'GET_CIC_ALERT_SUCCESS';
export const GET_CIC_ALERT_FAILURE = 'GET_CIC_ALERT_FAILURE';

function request() {
  return {
    type: GET_CIC_ALERT_REQUEST,
    isCicAlertLoading: true,
    cicAlert: null,
    cicAlertError: null
  };
}

function receive(cicAlert) {
  return {
    type: GET_CIC_ALERT_SUCCESS,
    isCicAlertLoading: false,
    cicAlert,
    cicReviewState: cicAlert.review,
    workflowState: cicAlert.workflow,
    cicAlertError: null
  };
}

function reject(cicAlertError) {
  return {
    type: GET_CIC_ALERT_FAILURE,
    isCicAlertLoading: false,
    cicAlertError
  };
}

export function getCicAlert(id) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getCicAlert(id)
      .then((response) => {
        dispatch(receive(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}

export function takeCicAlert(id) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .takeCicAlert(id)
      .then((response) => {
        dispatch(receive(response.data));
        dispatch(getCicAlertCounts());
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
